<template>
    <section>
        <!--工具条-->
        <el-col :span="24" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="search">
                <el-form-item label="物料编码">
                    <el-input v-model="search.matnr" placeholder="请输入物料编码"></el-input>
                </el-form-item>
                <el-form-item label="物料名称">
                    <el-input v-model="search.maktx" placeholder="请输入物料名称"></el-input>
                </el-form-item>
                <el-form-item label="物料类型">
                    <el-input v-model="search.mtart" placeholder="请输入物料类型"></el-input>
                </el-form-item>
                <el-form-item label="货号">
                    <el-input v-model="search.bismt" placeholder="请输入货号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  @click="query()">查询</el-button>
                </el-form-item>
                 <el-form-item>
                    <el-button type="primary"  @click="check()">确认</el-button>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col :span="24">
            <!--列表-->
            <el-table :data="data" v-loading="listLoading" row-key="Id" style="width: 100%"
             ref="table" class="custom-tbl" highlight-current-row  @selection-change="CurrentChange">
              <el-table-column
                type="selection"
                width="55">
                </el-table-column>
                <el-table-column prop="MATNR" label="物料编号" width></el-table-column>
                <el-table-column prop="MAKTX" label="物料描述" width="150"></el-table-column>
                <el-table-column prop="MSTAEString" label="物料状态" width>
                </el-table-column>
                <el-table-column prop="MTBEZ" label="物料类型描述" width></el-table-column>
                <el-table-column prop="ZQJBSString" label="物料标识" width></el-table-column>
                <el-table-column prop="MTART" label="物料类型" width></el-table-column>
                <el-table-column prop="MATKL" label="物料组" width></el-table-column>
                <el-table-column prop="WGBEZ" label="物料组描述" width></el-table-column>
                <el-table-column prop="BISMT" label="货号" width></el-table-column>
                <el-table-column prop="MEINS" label="基本计量单位" width></el-table-column>
                <el-table-column prop="MSTAE" label="跨工厂物料状态" width></el-table-column>
            </el-table>
        </el-col>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="total, sizes,prev, pager, next" @current-change="handleCurrentChange"
                @size-change="handleSizeChange" :current-page.sync="page" :page-size="intPageSize" :total="total"
                style="float: right"></el-pagination>
        </el-col>
    </section>
</template>

<script>
    import util from '../../../../util/date'
    import {getButtonList} from "../../../promissionRouter";
    import {getSapManagePageList} from '../../../api/api';
    import { SERIES_LAYOUT_BY_ROW } from 'echarts/lib/data/helper/sourceType';
    export default {
        data() {
            return {
                buttonList:[],
                search: { matnr: "" ,maktx:"",mtart:"",mtakl:"",bismt:""},
                total: 0,
                page: 1,
                intPageSize:20,
                listLoading: false,
                data:[],

                currentRow:[]  //单选选中数据
            }
        },
        methods: {
            CurrentChange(val)
            {
                this.currentRow = val;
            },
            getSapManagePageList() {
                this.listLoading=true;
                let para = {
                    matnr: this.search.matnr,
                    maktx: this.search.maktx,
                    mtart: this.search.mtart,
                    bismt: this.search.bismt,
                    page: this.page,
                    intPageSize:this.intPageSize,
                }
                getSapManagePageList(para).then((res) => {
                    console.log(res);
                    this.total= res.data.dataCount;
                    this.data = res.data.data;
                    this.listLoading=false;
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getSapManagePageList();
            },
            handleSizeChange(val){
               this.intPageSize = val;
               this.getSapManagePageList();
            },
            //查询
            query()
            {
               console.log("查询")
               this.page = 1;
               this.getSapManagePageList();
            },
            check()
            {
                let row = this.currentRow;
                if(!row)
                {
                    this.$message({
                            message: "请选择您需要添加的物料！",
                            type: "error",});
                            return;
                    
                }else
                {
                    this.$emit("change",row);
                }
            }
        },
        mounted() {
            this.getSapManagePageList();
        }
    }

</script>

<style>
    .role-item {
        cursor: pointer;
        padding: 10px;
    }

    .role-item.active {
        background: #ebf5ff;
    }

    .role-item:hover {
        background: #ebf5ff;
    }

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }

    .text {
        font-size: 14px;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

    .box-card {
        width: 90%;
    }


    .morechildren .el-checkbox{
        margin-right: 5px !important;
        float: left;
    }
    .morechildren .el-checkbox-group{
        margin-left: 50px;
        padding: 5px;
    }
    .morechildren .el-tree-node__content{
        height: auto !important;
    }
</style>
